import { tv } from 'tailwind-variants';

export const focusRingStyles = tv({
  base: 'focus-visible:outline-hidden focus-visible:ring-2',
  variants: {
    variant: {
      default:
        'focus-visible:ring-ds-stroke-primary focus-visible:ring-offset-2 focus-visible:ring-offset-ds-surface-foundation',
      input:
        'focus-visible:border-ds-neutral-9 focus-visible:bg-ds-surface-foundation focus-visible:text-ds-text-primary focus-visible:ring-ds-stroke-secondary',
    },
    interactiveChildren: {
      true: '',
    },
  },
  compoundVariants: [
    {
      variant: 'default',
      interactiveChildren: true,
      className:
        'focus-within:ring-2 focus-within:ring-ds-stroke-primary focus-within:ring-offset-2 focus-within:ring-offset-ds-surface-foundation',
    },
    {
      variant: 'input',
      interactiveChildren: true,
      className:
        'focus-within:ring-2 focus-within:border-ds-neutral-9 focus-within:bg-ds-surface-foundation focus-within:text-ds-text-primary focus-within:ring-ds-stroke-secondary',
    },
  ],
  defaultVariants: {
    variant: 'default',
    interactiveChildren: false,
  },
});
